import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TestHooks } from './missing-info-anchor.hooks';

@Component({
	selector: 'app-missing-info-anchor',
	templateUrl: './missing-info-anchor.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MissingInfoAnchorComponent {
	testHooks = TestHooks;
	@Input() href: string;
}
